import React from 'react';
import { Breadcrumb, Button } from 'react-bootstrap';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import checkgif from "../assets/check.gif";

const Styles = styled.div`  
.list-decimal {
    list-style-type: decimal;
} 

.content-top-header {
    color: #a6192e;
}

.breadcrumb-bg { 
    background-color:#e9ecef;
}


`;


const Successful = () => {
    const { t } = useTranslation(); // LANGUAGE

    return (
        <Styles>
            <div className="row breadcrumb-bg animate__animated animate__fadeIn">
                <div className="container">
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">
                            <small>
                                {/* Home */}
                                {t('mainpage-btn.4')}
                            </small>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/">
                            <small>
                                {/* Visitor Facilitation */}
                                {t('mainpage-btn.5')}
                            </small>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            <small>
                                {/* Successful */}
                                {t('short-word.2')}
                            </small>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>

            <div className="container">
                <br />
                <div className="content-message">
                    <div className="container animate__animated animate__fadeIn">
                        <div className="row justify-content-center check-message">
                            <h3>
                                {/* Registration Successful! */}
                                {t('short-word.4')}
                            </h3>
                        </div>
                        <div className="row justify-content-center">
                            <img src={checkgif} alt="check" height="100" width="100" />
                        </div>
                        <div className="row justify-content-center">
                            <div className="container">
                                <center><b>
                                    <p>
                                        {/* Please proceed to .... */}
                                        {t('check-message.1')}
                                    </p>
                                </b></center>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="animate__animated animate__bounceIn animate__delay-1s" />

                <div className="content-top">
                    <h5 className="content-top-header animate__animated animate__fadeInLeft animate__delay-500ms">
                        {/* IMPORTANT REMINDER */}
                        {t('short-word.15')}
                    </h5>
                    <p className="animate__animated animate__fadeInUp">
                        {/* Before visiting TTSH, please take note of the following to ensure smooth access at the gantries */}
                        {t('long-word.15')}
                    </p>
                    <ol className="list-decimal animate__animated animate__fadeInUp">
                        <li>
                            {/* Visitors are required to bring along one of the following identification cards for scanning at the gantries: */}
                            {t('long-word.16')}
                        </li>
                        <ul>
                            <li>
                                {/* NRIC/FIN */}
                                {t('short-word.16')}
                            </li>
                            <li>
                                {/* Driving Licence */}
                                {t('short-word.17')}
                            </li>
                            <li>
                                {/* Student/Senior Citizen EZ-link card */}
                                {t('short-word.18')}
                            </li>
                            <li>
                                {/* Employment pass */}
                                {t('short-word.19')}
                            </li>
                            <li>
                                S-pass
                                {/* {t('short-word.20')} */}
                            </li>
                            <li>
                                {/* Work Permit pass */}
                                {t('short-word.21')}
                            </li>
                        </ul>
                        <li>
                            {/* Visitors without any identification card may approach the Visitor Registration Counter at Level 1 Lift Lobbies to obtain a registration pass for entry. */}
                            {t('long-word.17')}
                        </li>
                        <li>
                            {/* When the visiting slots are full, the next visitor will receive an SMS notification once the next slot is available. */}
                            {t('long-word.18')}
                        </li>
                        <li>
                            {/* All information provided will be kept confidential and used solely for the purpose of ward visitation and contact tracing, if needed */}
                            {t('long-word.19')}
                        </li>
                    </ol>
                </div>
                <br />
                <div className="row animate__animated animate__fadeInUp animate__delay-1s">
                    <div className="container">
                        {/* <Button className="btn btn-primary col-md-4 offset-md-4" type="primary" href="/">OK</Button> */}
                        <Button className="btn btn-primary col-md-2 col-sm-12" type="primary" href="/">
                            {/* OK */}
                            {t('mainpage-btn.8')}
                        </Button>
                    </div>
                </div>

            </div>
        </Styles>
    );
};

export default Successful;